export const GlobalConstants = {
  API_BASE: '/api/v1',
  API_URL: 'http://3.210.159.100',
  FULL_API_URL: 'http://3.210.159.100/api/v1',

  TOKEN_KEY: 'ks_auth_token',
  REFRESH_KEY: 'ks_refresh_token',
  USER_KEY: 'ks_user',

  USER_ROLES: {
    ADMIN: 'ADMIN',
    FAMILY_LEAD: 'FAMILY_LEAD',
    FAMILY_MEMBER: 'FAMILY_MEMBER',
  },

  PUBLIC_PATHS: [
    '/auth/login',
    '/auth/register',
    '/auth/verify-otp',
    '/auth/resend-otp',
    '/auth/otp-login',
    '/auth/refresh',
    '/auth/password/',
    '/family/invites/accept',
    '/billing/plans/public',
    '/mobile-app/latest',
    '/api/v1/health',
  ],

  PAGE_SIZE: 20,

  TOAST: {
    SUCCESS: 'success',
    ERROR: 'error',
  },

  COMPONENT: {
    USERS_LIST: 'ks-users-list',
    ROLES_LIST: 'ks-roles-list',
    SUBSCRIPTIONS_LIST: 'ks-subscriptions-list',
    LOGIN: 'ks-login',
    REGISTER: 'ks-register',
  },

  /** Admin plan catalogue (KS-09) form and storage constraints. */
  PLAN: {
    /** Wire value for "no cap" on storageGb / memberLimit. */
    UNLIMITED: -1,
    CODE_MAX: 40,
    NAME_MIN: 2,
    /** Matches the backend's @Size(max = 20) on PlanRequest.name. */
    NAME_MAX: 20,
    /** Matches the backend's @Size(max = 50) on PlanRequest.description. */
    DESCRIPTION_MAX: 50,
    /** DECIMAL(10,2): eight integer digits and two fractional digits. */
    PRICE_MAX: 99_999_999.99,
    SCOPES: ['FAMILY', 'ORGANIZATION', 'BOTH'],
  },

  /** Admin add-on catalogue (KS-09). Same string limits as plans. */
  ADDON: {
    /** Backend: ^[A-Z0-9]{3,40}$ — same shape coupon codes already had. */
    CODE_MIN: 3,
    CODE_MAX: 40,
    NAME_MIN: 2,
    NAME_MAX: 20,
    DESCRIPTION_MAX: 50,
    PRICE_MAX: 99_999_999.99,
    /** Per-unit capacity ceiling — a sanity bound, not a backend constraint. */
    UNIT_MAX: 9_999,
    TYPES: ['EXTRA_STORAGE', 'EXTRA_MEMBERS'],
    SCOPES: ['FAMILY', 'ORGANIZATION', 'BOTH'],
  },
} as const;
